import { render } from "./LogoHaikaraWhite.vue?vue&type=template&id=65885653&scoped=true"
import script from "./LogoHaikaraWhite.vue?vue&type=script&lang=js"
export * from "./LogoHaikaraWhite.vue?vue&type=script&lang=js"

import "./LogoHaikaraWhite.vue?vue&type=style&index=0&id=65885653&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65885653"]])

export default __exports__